export default "<div class=\"avatar mr-1\" [ngClass]=\"classes\"><img class=\"avatar-img img-fluid\" [src]=\"imageSrc\" /></div>\n"